import React, {useContext, useState, useEffect} from 'react'
import {MyAccountContext} from '../../containers/Layout'
//import {qualifiedConstantSchema} from '../../utils/constants.js'
import CardSelector from '../../components/CardSelector'
import GridContainer from '../../components/Grid/GridContainer'
import {prependZero} from '../../../utils/utils'
import {Grid, Typography, Paper} from '@material-ui/core'
import NoResultFound from '../../../components/NoResultFound/NoResultFound'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {getMyAccountAPIData} from '../../services/myaccount'
import Loader from '../../../components/Loader'

const Qualified = props => {
    const {
        routeObject,
        setrouteObject,
        clientObject,
        setClientObject,
        qualifiedObject,
        setqualifiedProgram,
        practiceObject,
        myAccountSchema,
    } = useContext(MyAccountContext)

    const [loading, setloading] = useState(false)
    let array = []

    useEffect(() => {
        getAvailablePrograms()
    }, [])

    const cardHandler = obj => {
        switch (obj.actiontype.toLowerCase()) {
            case 'details':
            case 'knowmore':
                setrouteObject({
                    ...routeObject,
                    key: obj.key,
                    actiontype: obj.actiontype,
                    logo: obj.logo,
                    backrouter: 'qualified',
                    registryinfo: obj.registryinfo,
                    providertab: obj.cliniciandetails,
                })
                setClientObject({
                    ...clientObject,
                    clientprogramid: obj.clientprogramid || 0,
                    clientprogramname: obj.clientprogramname || '',
                    programid: obj.programid || 0,
                    programhost: obj.programhost || '',
                    mipsdateexpired: obj.mipsdateexpired,
                    mipsdateexpiredmessage: obj.mipsdateexpiredmessage,
                })
                break

            default:
                break
        }
    }

    const getAvailablePrograms = () => {
        setloading(true)
        const callApi = async () => {
            const data = await getMyAccountAPIData(
                'cliententity/availableprogram',
                {},
                {'client-entity-id': clientObject.cliententityid}
            )

            if (Object.entries(data).length > 0) {
                if (data.error && Object.keys(data.error).length > 0)
                    setqualifiedProgram({
                        availableprogram: [],
                    })
                else setqualifiedProgram(data)
            } else
                setqualifiedProgram({
                    availableprogram: [],
                })

            setloading(false)
        }
        callApi()
    }

    if (qualifiedObject.availableprogram && qualifiedObject.availableprogram.length > 0) {
        qualifiedObject.availableprogram.forEach((input, key) => {
            let availableSchema
            const arrayOfAvailable = []
            qualifiedObject.availableprogram.forEach(schema => {
                availableSchema = {}
                availableSchema = JSON.parse(
                    JSON.stringify(myAccountSchema.qualifiedConstantSchema)
                )
                availableSchema.data = schema
                availableSchema.columnMedia[0]['imageUrl'] = schema.logo
                arrayOfAvailable.push(availableSchema)
            })
            arrayOfAvailable.map(e => {
                e['cardClickHandler'] = {cardHandler}
                e['avilableProgramFun'] = {getAvailablePrograms}
            })
            input.value = []
            input.value = arrayOfAvailable
            array = arrayOfAvailable
        })
    }

    const AvailableProgramCards = () => {
        if (array.length === 0) {
            return (
                <Paper className="no-data_page white-wrapper-bg">
                    <Grid item xs={12} className="table-root__wrapper">
                        <NoResultFound
                            message={props.message || 'No available program right now'}
                            imageName="Empty_container"
                        />
                    </Grid>
                </Paper>
            )
        } else {
            return (
                <GridContainer>
                    {array.map((schema, index) => {
                        return (
                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                <CardSelector
                                    key={'qualifiedCard_' + index}
                                    {...schema}
                                ></CardSelector>
                            </Grid>
                        )
                    })}
                </GridContainer>
            )
        }
    }

    const header = qualifiedObject.availableprogram
        ? 'AVAILABLE PROGRAMS (' +
          (prependZero(qualifiedObject.availableprogram.length) || 0) +
          ')'
        : 'AVAILABLE PROGRAMS (0)'

    return (
        <div className="ma-main-page__wrapper prgrm-hdr__wrpr ">
            <Grid container spacing={3} className="program-dtls_header">
                <Grid item className="program-header__ttl">
                    <Typography
                        className="form-row--heading_h6"
                        variant="h6"
                        gutterBottom
                    >
                        <FontAwesomeIcon
                            icon={['fal', 'angle-left']}
                            onClick={() => props.setRouter('dashboard')}
                        ></FontAwesomeIcon>
                        &nbsp;
                        {header}
                    </Typography>
                </Grid>
                <Grid item xs className="program-header__practice-name__wrapper">
                    <Grid xs className="program-header__practice-name">
                        <div className="practice__name">
                            {' '}
                            {practiceObject.practicename}
                            <span className="practice__id">
                                ({practiceObject.practiceId})
                            </span>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            {loading && <Loader type="page" />}
            {!loading && <AvailableProgramCards />}
        </div>
    )
}

export default Qualified
